
const { BUILD_TYPE } = process && process.env;
console.log('BUILD_TYPE===', process)
console.log('BUILD_TYPE===', process.env)
if (BUILD_TYPE !== 'development') {
  var scriptEle = document.createElement('script');
  scriptEle.src = 'https://statics-lib.zmlearn.com/zm-jssdk/stable/zm-jssdk.js';
  scriptEle.onload = function () {
    window.ZM_JSSDK && window.ZM_JSSDK.setConfig({
      environment: BUILD_TYPE === 'prod' ? 'prod' : 'fat',
      logLevel: BUILD_TYPE === 'prod' ? 'error' : 'debug',
      history: true,
      urlParams: true,
    });

    window.ZM_JSSDK && window.ZM_JSSDK.setDefaults({
      appId: '12929',
      appVersion: '1.0.0',
      cSource: 'h5'
    });

  };
  document.documentElement.appendChild(scriptEle);
}